import { UserRoleScreen } from '@/screens/create-game/UserRoleScreen'

export default function () {
  return <UserRoleScreen />
}
